Init_Render()

document.addEventListener("on:variant:change",Handle_Variant_Change)

function Init_Render(){
  
  let urlSearch = new URLSearchParams(window.location.search);
  
  const data = JSON.parse(document.querySelector('variant-picker [type="application/json"]').textContent);
  let full_variant
  if (urlSearch.get("variant") != null){
    let id = urlSearch.get("variant");
    full_variant = data["formatted"][id]
    

  }else{
    let id = data["product"]["variants"][0]["id"]
    full_variant = data["formatted"][id]
    
  }
  let diameter = Math.round(full_variant["diameter"]*10)
  let thickness = Math.round(full_variant["thickness"]*10)    
  Replace_Product_Image_With_Render(`optics-render/?diameter=${diameter}&thickness=${thickness}&material=kbr&distance=75`)
}

function Handle_Variant_Change(event){
  let form = event.detail["form"]
  let render = document.getElementById("render-3d").contentWindow
  const data = JSON.parse(document.querySelector('variant-picker [type="application/json"]').textContent);

  const full_variant = data["formatted"][event.detail["variant"]["id"]]
  let message = {
    "diameter":parseFloat(full_variant["diameter"]),
    "thickness":parseFloat(full_variant["thickness"]),
    "material":"kbr"
  }
  render.postMessage(message, "https://only-solutions-connect.com")
  console.log(message)
}

function Replace_Product_Image_With_Render(target){
    let media_container = document.getElementById("product-media")
    let render_container = document.createElement("div")
    render_container.classList.add("div-render-3d")

    let render = document.createElement("iframe")
    render.setAttribute("id","render-3d")
    render.classList.add("standard-render-3d")
    render.alt = "Custom IR optics displayed in 3D"
    render.src = "https://only-solutions-connect.com/simply-photonics/customizer/"+target
    render_container.append(render)
    
    media_container.replaceChildren(render_container)

}